var navBySelect = document.querySelector('.home .home-professions-select'),
    simulatorLabel = 'form#cmvm-simulator #professions-autocomplete',
    simulatorProfession = 'form#cmvm-simulator input[name=profession]',
    cookiename = 'cmvm_profession';
/**
 * Set cookie
 *
 * @see https://www.w3schools.com/js/js_cookies.asp
 *
 * @param name the cookie name
 * @param value the value of the cookie.
 * @param exdays The number of day until the cookie should expire.
 */
function setCookie(name, value, exdays) {
    var expires = '';

    if (typeof exdays === 'undefined') {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = "expires=" + d.toUTCString();
    }

    document.cookie = name + '=' + value + ";" + expires;
}
/**
 * Retrieve cookie
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#Example_2_Get_a_sample_cookie_named_test2
 *
 * @param name The name of the cookie should retrieve value.
 * @return {string}
 */
function getCookie(name) {
    var regex = new RegExp('(?:(?:^|.*;\\s*)'+name+'\\s*\\=\\s*([^;]*).*$)|^.*$');
    return document.cookie.replace(regex, "$1");
}
/**
 * Searches into object for given value and return the first corresponding key if successful.
 *
 * @param needle the search value
 * @param obj The object
 * @return {boolean} Return the key for needle if found in the object of false otherwise.
 */
function objSearch(needle, obj) {
    var property = false;
    for (var key in obj) {
        var value = obj[key];

        if (value === needle) {
            property = key;
            break;
        }
    }
    return property;
}

/**
 * Set selector profession from profession's simulator value.
 * This function work only in front-page.
 * @param profession
 */
function setProfessionHome(profession) {
    var value = objSearch(profession, window.cmvm_profession_mapping);
    if (value && navBySelect) {
        navBySelect.value = value;
        navBySelect.dispatchEvent(new Event('change'));
    }
}

/**
 * This script uses jquery ui autocomplete to enable users to search and select jobs quickly
 * from a profession list defined into the global object variable cmvm_profession.
 * The script detects the autocomplete fields with tags #form-simulator #professions.
 *
 * To showing the label instead of the value in input field, we use two fields
 * the first for autocompletion and the second for the value to submit to the form.
 * @type {object} cmvm_profession
 */
(function ($) {
    var field = $(simulatorLabel), // Field use to display the label select from auto complete.
        fieldProfession = $(simulatorProfession); // Field use to set value send on submit

    var accentMap = {
        "à": "a",
        "â": "a",
        "é": "e",
        "è": "è",
        "ë": "e",
        "ê": "e",
        "î": "i",
        "ï": "i",
        "ô": "o",
        "ö": "o",
        "ù": "u",
        "ü": "u",
        "û": "u"
    };

    var normalize = function( term ) {
        var ret = "";
        for ( var i = 0; i < term.length; i++ ) {
        ret += accentMap[ term.charAt(i) ] || term.charAt(i);
        }

        return ret;
    };

    var professionValue = fieldProfession.val();
    // Set profession value if is set into fieldProfession.
    if (professionValue) {
        field.val(cmvm_profession[professionValue]);
    }

    // Check jQuery UI autocomplete exist.
    if (typeof  field.autocomplete === 'function') {
        field.autocomplete({
            source: function (request, response) {
                var matcher = new RegExp('(^|[ -])' + $.ui.autocomplete.escapeRegex(request.term), 'i');
                response($.map(cmvm_profession, function (item, key) {
                    if (matcher.test(item) || matcher.test(normalize(item))) {
                        return {label: item, value: key};
                    }
                }));
            },
            select: function (event, ui) {
                event.preventDefault();
                field.val(ui.item.label); // display the label instead of the value
                fieldProfession.val(ui.item.value); // set field profession with the value.
            },
            focus: function (event, ui) {
                event.preventDefault();
                field.val(ui.item.label);
                fieldProfession.val(ui.item.value);
                setProfessionHome(ui.item.value);
                setCookie(cookiename, ui.item.value, 5);
            }
        });
    }

})(jQuery);

/**
 * Add event listener on change list profession from home page to update profession's simulator field.
 */
if (navBySelect) {
    navBySelect.addEventListener('change', function () {
        var profession = window.cmvm_profession_mapping[this.value];
        if (profession) {
            setCookie(cookiename, profession, 5);
            document.querySelector(simulatorLabel).value = cmvm_profession[profession];
            document.querySelector(simulatorProfession).value = profession;
        }
    });
}

/**
 * Set professions simulator field and profession selector home page.
 */
window.onload = function () {
    /**
     * The query selector is redefine because is not accessible on windows.load.
     */
    var nav = document.querySelector('.home .home-professions-select'), // selector list profession home page.
        // Retrieve current cookie.
        cookie = getCookie(cookiename),
        // field simulator.
        simulator = document.querySelector('form#cmvm-simulator #professions-autocomplete'),
        // Selector to detect if is page simulator
        isPageSimulator = document.querySelector('body.page-template-template-simulation-php');

    /**
     * Set list of profession display in home page.
     */
    if (nav && cookie) {
        setProfessionHome(cookie);
    }
    /**
     * Update profession field's simulator from all page except the home page and simulator template.
     */
    if (isPageSimulator === null && nav === null && cookie) {
        simulator.value = cmvm_profession[cookie];
        document.querySelector(simulatorProfession).value = cookie;
    }
};
